const ChipIcon = () => {
  return (
    <svg
      width="33"
      height="32"
      viewBox="0 0 33 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M16.5754 4.33398C19.0257 4.33396 20.9666 4.33395 22.4855 4.53817C24.0488 4.74834 25.314 5.19116 26.3118 6.18898C27.3097 7.18679 27.7525 8.45206 27.9627 10.0153C28.1669 11.5342 28.1669 13.6255 28.1668 16.0759V16.0759C28.1669 18.5263 28.1669 20.4671 27.9627 21.986C27.7525 23.5492 27.3097 24.8145 26.3118 25.8123C25.314 26.8101 24.0488 27.253 22.4855 27.4631C20.9666 27.6674 19.0258 27.6673 16.5754 27.6673H16.5754C14.125 27.6673 12.0338 27.6674 10.5148 27.4631C8.95157 27.253 7.68631 26.8101 6.68849 25.8123C5.69067 24.8145 5.24785 23.5492 5.03768 21.986C4.83346 20.4671 4.83348 18.5262 4.8335 16.0759V16.0759C4.83348 13.6255 4.83346 11.5342 5.03768 10.0153C5.24785 8.45206 5.69067 7.18679 6.68849 6.18898C7.68631 5.19116 8.95157 4.74834 10.5148 4.53817C12.0338 4.33395 14.125 4.33396 16.5754 4.33398H16.5754Z"
        fill="#FF0000"
      />
      <path
        d="M12.1665 2.66699C12.1665 2.11471 11.7188 1.66699 11.1665 1.66699C10.6142 1.66699 10.1665 2.11471 10.1665 2.66699V4.58939C10.2808 4.5708 10.3968 4.55366 10.5145 4.53784C11.0073 4.47158 11.5604 4.42682 12.1665 4.39658V2.66699Z"
        fill="#FF0000"
      />
      <path
        d="M17.4998 4.33409C17.2 4.33365 16.8918 4.33366 16.5751 4.33366C16.2087 4.33366 15.8495 4.33365 15.4998 4.33433V2.66699C15.4998 2.11471 15.9476 1.66699 16.4998 1.66699C17.0521 1.66699 17.4998 2.11471 17.4998 2.66699V4.33409Z"
        fill="#FF0000"
      />
      <path
        d="M22.4852 4.53784C22.6029 4.55366 22.7189 4.5708 22.8332 4.58939V2.66699C22.8332 2.11471 22.3855 1.66699 21.8332 1.66699C21.2809 1.66699 20.8332 2.11471 20.8332 2.66699V4.39468C21.4323 4.42493 21.9819 4.47017 22.4852 4.53784Z"
        fill="#FF0000"
      />
      <path
        d="M20.8332 27.606C21.4323 27.5757 21.9819 27.5305 22.4852 27.4628C22.6029 27.447 22.7189 27.4299 22.8332 27.4113V29.3337C22.8332 29.8859 22.3855 30.3337 21.8332 30.3337C21.2809 30.3337 20.8332 29.8859 20.8332 29.3337V27.606Z"
        fill="#FF0000"
      />
      <path
        d="M16.567 27.667C16.2031 27.667 15.8472 27.667 15.4998 27.6663V29.3337C15.4998 29.8859 15.9476 30.3337 16.4998 30.3337C17.0521 30.3337 17.4998 29.8859 17.4998 29.3337V27.6666C17.2034 27.667 16.8987 27.667 16.5858 27.667H16.567Z"
        fill="#FF0000"
      />
      <path
        d="M10.1665 27.4113C10.2808 27.4299 10.3968 27.447 10.5145 27.4628C11.0073 27.5291 11.5604 27.5738 12.1665 27.6041V29.3337C12.1665 29.8859 11.7188 30.3337 11.1665 30.3337C10.6142 30.3337 10.1665 29.8859 10.1665 29.3337V27.4113Z"
        fill="#FF0000"
      />
      <path
        d="M16.5715 8.33366C18.0819 8.33363 19.3162 8.3336 20.2907 8.46462C21.3093 8.60157 22.1924 8.89794 22.8973 9.60287C23.6022 10.3078 23.8986 11.1909 24.0355 12.2095C24.1666 13.184 24.1665 14.5117 24.1665 16.0221C24.1665 17.0575 24.1665 17.9549 24.1285 18.7168C24.1162 18.9645 24.0122 19.1987 23.8369 19.3741L19.8736 23.3374C19.6982 23.5127 19.464 23.6167 19.2163 23.629C18.4544 23.667 17.5571 23.667 16.5217 23.667C15.0113 23.667 13.6835 23.6671 12.709 23.536C11.6904 23.3991 10.8073 23.1027 10.1024 22.3978C9.39745 21.6929 9.10108 20.8097 8.96413 19.7911C8.83311 18.8167 8.83314 17.5824 8.83317 16.0719C8.83314 14.5615 8.83311 13.184 8.96413 12.2095C9.10108 11.1909 9.39745 10.3078 10.1024 9.60287C10.8073 8.89794 11.6904 8.60157 12.709 8.46462C13.6835 8.3336 15.061 8.33363 16.5715 8.33366Z"
        fill="#FF0000"
      />
      <path
        d="M3.1665 9.66699H5.08891C5.07031 9.7813 5.05317 9.89729 5.03735 10.015C4.97109 10.5078 4.92633 11.0609 4.89609 11.667H3.1665C2.61422 11.667 2.1665 11.2193 2.1665 10.667C2.1665 10.1147 2.61422 9.66699 3.1665 9.66699Z"
        fill="#FF0000"
      />
      <path
        d="M3.1665 15.0003H4.83385C4.83316 15.35 4.83317 15.7084 4.83317 16.0748C4.83317 16.3915 4.83317 16.7005 4.8336 17.0003H3.1665C2.61422 17.0003 2.1665 16.5526 2.1665 16.0003C2.1665 15.448 2.61422 15.0003 3.1665 15.0003Z"
        fill="#FF0000"
      />
      <path
        d="M4.89419 20.3337H3.1665C2.61422 20.3337 2.1665 20.7814 2.1665 21.3337C2.1665 21.8859 2.61422 22.3337 3.1665 22.3337H5.08891C5.07031 22.2193 5.05317 22.1034 5.03735 21.9857C4.96968 21.4824 4.92444 20.9328 4.89419 20.3337Z"
        fill="#FF0000"
      />
      <path
        d="M29.8332 22.3337H27.9108C27.9294 22.2193 27.9465 22.1034 27.9623 21.9857C28.03 21.4824 28.0752 20.9328 28.1055 20.3337H29.8332C30.3855 20.3337 30.8332 20.7814 30.8332 21.3337C30.8332 21.8859 30.3855 22.3337 29.8332 22.3337Z"
        fill="#FF0000"
      />
      <path
        d="M28.1661 17.0003H29.8332C30.3855 17.0003 30.8332 16.5526 30.8332 16.0003C30.8332 15.448 30.3855 15.0003 29.8332 15.0003H28.1658C28.1665 15.3476 28.1665 15.7036 28.1665 16.0675V16.0863C28.1665 16.3992 28.1665 16.7039 28.1661 17.0003Z"
        fill="#FF0000"
      />
      <path
        d="M29.8332 11.667H28.1036C28.0733 11.0609 28.0286 10.5078 27.9623 10.015C27.9465 9.89729 27.9294 9.7813 27.9108 9.66699H29.8332C30.3855 9.66699 30.8332 10.1147 30.8332 10.667C30.8332 11.2193 30.3855 11.667 29.8332 11.667Z"
        fill="#FF0000"
      />
    </svg>
  );
};

export default ChipIcon;
